
import { defineComponent, PropType, ref, computed, watch } from 'vue'
import ActionsCell from '@/components/list/parts/ActionsCell.vue'
import { formatDateWithFormat } from '@/core/helpers/DatetimeConverter'

type GameItem = {
  id: number|string
  leagueId: number|string
  leagueName: string
  homeTeamName: string
  awayTeamName: string
  homeTeamGoals: string
  awayTeamGoals: string
  gameDate?: string
  gameTimeMinutes?: string
  // ...I�,I,I1 I�I�I�I� I-I�I�I1I, I�I,I� row
}

export default defineComponent({
  name: 'DataGridWithLeagues',
  components: { ActionsCell },
  props: {
    title: { type: String, default: 'Matches' },
    routeKey: { type: String, required: true },
    mapping: { type: Object as PropType<any>, required: true },
    items: { type: Array as PropType<GameItem[]>, required: true },
  },
  emits: ['open-modal','delete','row-action'],
  setup (props) {
    const q = ref('')
    const activeLeagueId = ref<string|number|null>(null)

    // I�I?I�I1I�I�I?I�I_I�I�I� I�I�I�I?I3IrI, I�I_I3I�I�I, (I?I?IZI,I� I�I?IO I,I� I�I_I�I,I�)
    watch(() => props.items, (list) => {
      if (!list?.length) return
      if (activeLeagueId.value == null) activeLeagueId.value = list[0].leagueId
    }, { immediate: true })

    // const leagues = computed(() => {
    //   const map = new Map<string|number, string>()
    //   for (const g of props.items) map.set(g.leagueId, g.leagueName)
    //   return Array.from(map, ([id, name]) => ({ id, name }))
    // })
  const leagues = computed(() => {
    const map = new Map<string|number, string>();
    for (const g of filteredItems.value) map.set(g.leagueId, g.leagueName);
    return Array.from(map, ([id, name]) => ({ id, name }));
  });
    const filteredLeagues = computed(() => {
      const t = normalize(q.value);
      if (!t) return leagues.value;
      // I�I'IZ I�I?I�I?I�I_I, I�I?I�I� I�I� I�I?I1I�I,I?I-I^I�I1I, I,I1I, leagues I�I+I�I? IrI'I� I�I3I�I_I�I�I.I� I�I?IO filteredItems
      return leagues.value;
    });

    const normalize = (v?: string) =>
  (v ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // I�I+I�I1I?I�I_ I,IOI�I�I.I, I�I%I?I_I, \p{Diacritic}

    const filteredItems = computed(() => {
      const t = normalize(q.value);
      if (!t) return props.items ;
      return (props.items).filter(o =>
        [o.leagueName, o.homeTeamName, o.awayTeamName].some(v => normalize(v).includes(t))
      );
    });

    const activeLeague = computed(() =>
      leagues.value.find(l => l.id === activeLeagueId.value) || null
    )

    // const leagueItems = computed(() =>
    //   props.items.filter(o => o.leagueId === activeLeagueId.value)
    // )

    const leagueItems = computed(() =>
      filteredItems.value.filter(o => o.leagueId === activeLeagueId.value)
    );
    const shortDate = (d: string) => {
      try { return formatDateWithFormat(d, 'D MMM. H:mm') } catch { return d }
    }
    watch(filteredLeagues, (ls) => {
      if (!ls.length) { activeLeagueId.value = null; return; }
      if (activeLeagueId.value == null || !ls.some(l => l.id === activeLeagueId.value)) {
        activeLeagueId.value = ls[0].id;
      }
    }, { immediate: true });

    return { q, activeLeagueId, filteredLeagues, activeLeague, leagueItems, shortDate }
  }
})
